import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { Mui, MuiStyles } from '@osu/react-ui';
import { NavLink } from 'react-router-dom';
import { NAVBAR_WRAPPER_ID } from '../../util/constants';
import AuthButton from '../components/AuthButton';
import PATHS from '../../Routes/paths';
import useRoleAuthentication from "../../Authentication/hooks/useRoleAuthentication";

const createClasses = (theme) => {
  return {
    appBar: {
      top: '0',
      zIndex: theme.zIndex.appBar,
    },
    root: {
      flexGrow: 1,
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1,
    },
    navIcon: {
      marginRight: '1.5rem',
    },
    navTitle: {
      marginRight: '1.5rem',
    },
    navDivider: {
      marginRight: '1rem',
    },
    navItem: {
      "&.active": {
          color: theme.palette.primary.main,
        },
      paddingTop: '.5rem',
      fontSize: '.8rem',
      marginRight: '1rem',
      color: theme.palette.secondary.main,
    },
  };
};

export default function Navbar(props = {}) {
  const auth = useRoleAuthentication();
  const navLinksToDisplay = auth.isAdmin ? PATHS : [];

  const theme = MuiStyles.useTheme();
  const classes = createClasses(theme);

  return (
    <Mui.AppBar
      id={NAVBAR_WRAPPER_ID}
      color="inherit"
      sx={classes.appBar}
      position="sticky"
    >
      <Mui.Toolbar>
        <ManageAccountsIcon sx={classes.navIcon} />
        <Mui.Box sx={classes.title}>
          <Mui.Typography sx={classes.navTitle}>
            User Access Management
          </Mui.Typography>
          <Mui.Divider
            orientation="vertical"
            flexItem
            sx={classes.navDivider}
          />
          {navLinksToDisplay.map((navLink) => (
            <Mui.Button sx={classes.navItem} to={navLink.path} component={NavLink}>
              {navLink.title}
            </Mui.Button>
          ))}
        </Mui.Box>
        <AuthButton />
      </Mui.Toolbar>
    </Mui.AppBar>
  );
}
